var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "220.000000pt",
    height: "220.000000pt",
    viewBox: "0 0 220.000000 220.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40.000000,280.000000) scale(0.11000,-0.11000)",
    fill: "#ff0000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1290 2374 c-157 -42 -274 -173 -303 -338 -10 -62 -13 -66 -38 -66 -83 0 -222 -70 -285 -143 -212 -248 -74 -631 248 -687 l64 -11 11 -66 c23 -133 105 -243 226 -303 253 -124 549 28 598 307 l11 61 61 11 c89 16 175 61 236 126 229 242 97 641 -232 698 l-66 11 -11 65 c-43 245 -282 399 -520 335z m235 -132 c92 -44 158 -132 172 -227 l6 -45 -302 0 -301 0 0 28 c0 92 97 222 190 255 75 26 165 22 235 -11z m-545 -693 l0 -302 -45 6 c-140 20 -255 151 -255 293 0 91 24 150 89 215 58 58 117 87 179 88 l32 1 0 -301z m720 1 l0 -300 -300 0 -300 0 0 300 0 300 300 0 300 0 0 -300z m255 269 c102 -51 171 -172 162 -285 -6 -80 -35 -143 -92 -198 -46 -45 -132 -86 -180 -86 l-25 0 0 301 0 302 44 -5 c24 -3 65 -16 91 -29z m-255 -714 c0 -48 -41 -134 -86 -180 -148 -152 -395 -112 -485 79 -16 34 -29 76 -29 94 l0 32 300 0 300 0 0 -25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusmark);
export default __webpack_public_path__ + "static/media/plusmark.7ca3040d95aeb380c7932557b8953a38.svg";
export { ForwardRef as ReactComponent };